<template>
<div class="page_set page">
    <div class="list">
        <div class="item touxiang">
            <div class="item_l">
                <span class="">修改头像</span>
                <van-uploader :after-read="changeThumb" accept class="icon-add">
                    <img :src="thumb ? ($publicData.withHttpStart(thumb) ? thumb : imageUrl+thumb) : $publicData.defaultTouxiang" alt="" class="thumb">
                </van-uploader>
            </div>
        </div>
        <div class="item" @click="goPage('set/nickname')">
            <div class="item_l">
                <span class="">修改昵称</span>
                <span class="">{{ nickname }}</span>
            </div>
        </div>
        <div class="item" @click="goPage('set/phone')">
            <div class="item_l">
                <span class="">修改手机号</span>
                <span class="">{{ phone }}</span>
            </div>
        </div>
        <!-- <div class="item" @click="goPage('set/nickname')">修改昵称</div> -->
        <!-- <div class="item">修改密码</div> -->
        <!-- <div class="item" @click="goPage('set/phone')">修改手机号</div> -->
        <div class="item jiebang" @click="show = true">
            <div class="item_l">
                <span>{{bindWX?'解绑微信':'绑定微信'}}</span>
                <img :src="publicPath+'statics/images/weixin-2.png'" alt="" class="icon_wechat">
            </div>
        </div>
    </div>
    <!-- 解绑微信 -->
    <van-dialog v-model="show" class="dialog" show-cancel-button @confirm="confirmWX" @cancle="show = false">
        <div class="title">确定{{bindWX?'解绑':'绑定'}}微信</div>
    </van-dialog>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "set-account",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            isClient: false, //是否在iOSAndroid客户端内显示
            token: null,
            show: false, // 解绑微信确认框
            thumb: null, // 头像
            phone: null, // 手机号
            nickname: null, // 昵称
            bindWX: null,
            imageUrl: Vue.prototype.$publicData.uploadImage,
            is_weixin: false, // 是否微信环境
            wxCode: null,//微信code
            getCodeUrl: 'https://mall.shidaijiyi.com/home/wx-code?url=/set/account' // 测试
        };
    },
    created: function () {
        
    },
    mounted: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            this.setClientInfo()
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.setClientInfo()
                responseCallback('refresh success')
            })
            //注册方法，右上角设置按钮点击事件
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                
                responseCallback('success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            var code = this.getUrlCode()["code"];
            if (code != null && code != undefined && code != '') {
                this.checkWeiXin()
            } else {
                this.getData();
            }
        }
    },
    methods: {
        setClientInfo() {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '账户信息',
                    // 'hiddenBack': true,
                    // 'rightStyle': 'setup'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            console.log('sdjy://member/memberInfo')
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData();
                }
            })
        },
        // 获取用户信息
        getData() {
            if (this.token == null) {
                return
            }
            var params = {
                token: this.token
            }
            this.$api.user.index(params).then(res => {
                console.log('res')
                console.log(res)
                if (res.code == 200) {
                    this.phone = res.result.info.users.username
                    this.thumb = res.result.info.thumb
                    window.localStorage.setItem('thumb', res.result.info.thumb);
                    this.nickname = res.result.info.nickname
                    // 是否绑了app的微信
                    // app_openid
                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                        if (res.result.info.users.app_openid && res.result.info.users.app_openid != undefined && res.result.info.users.app_openid != '') {
                            this.bindWX = true
                        } else {
                            this.bindWX = false
                        }
                    } else {
                        if (res.result.info.users.openid && res.result.info.users.openid != undefined && res.result.info.users.openid != '') {
                            this.bindWX = true
                        } else {
                            this.bindWX = false
                        }
                    }
                    
                }
            })
        },
        // 修改头像
        changeThumb(file) {
            var str = ''
            // 单张上传
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    str = res.result.url
                    // 修改头像
                    if (str) {
                        var params = {
                            token: this.token,
                            thumb: str
                        }
                        this.$api.my.thumb(params).then(res => {
                            if (res.code == 200) {
                                this.getData()
                            }
                        })
                    }
                }
            });

            console.log('str', str)
        },
        // 页面跳转
        goPage(path) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var name = path.replace("-", "/")
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl+'/' + name
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                this.$router.push({
                    path: '/' + path
                })
            }

        },
        // 判断 是否在微信环境
        checkWeiXin() {
            var ua = window.navigator.userAgent.toLowerCase()
            if (ua.indexOf('micromessenger') == -1) {
                console.log("不在微信或者小程序中")
                this.is_weixin = false
            } else {
                console.log('在微信环境')
                this.is_weixin = true
                var code = this.getUrlCode()["code"];
                console.log(code)
                if (this.token == null || this.token == undefined || this.token == '') {
                    this.token = this.$store.getters.token
                }
                console.log('this.token:'+this.token)
                if (code != null && code != undefined && code != "") {
                    var params = {
                        token: this.token,
                        code: code
                    }
                    this.$api.user.bindWX(params).then(res => {
                        if (res.code == 200) {
                            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                                var memberParams = {
                                    'data': {
                                        forceLogin: 1
                                    }
                                }
                                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                                    
                                })
                            } else {
                                this.$store.commit(LOGOUT);
                                this.$router.push("/login");
                            }
                        }
                    })
                }
            }
        },
        // 截取url中的code方法
        getUrlCode() {
            var allUrl = location.href;
            var url = allUrl.substring(allUrl.indexOf("?"), allUrl.length);
            this.winUrl = url;
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                var str = url.substr(1);
                var strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
                }
            }
            return theRequest;
        },
        // 确认解绑/绑定微信
        confirmWX() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                this.bindAppWx()
            } else {
                this.bindH5Wx()
            }
        },
        bindAppWx() {
            var that = this
            if (this.bindWX) {
                // 解绑
                var params = {
                    token: this.token
                }
                this.$api.user.unbindAppWX(params).then(res => {
                    if (res.code == 200) {
                        that.$toast('解绑成功')
                        that.getData()
                    }
                })
            } else {
                var params = {
                    'data': {}
                }
                that.$bridge.callhandler('sdjy://public/bindAppWX', params, (data) => {
                    console.log('bindAppWX')
                    console.log(data)
                    if (data.code == 200) {
                        if (data.result.code && data.result.code != undefined && data.result.code != '') {
                            var code = data.result.code
                            that.bingAPPWx(code);
                        } else {
                            that.bingAPPWxData(data.result)
                        }
                    }
                })
            }
            this.show = false
        },
        bingAPPWx(code) {
            var that = this
            var params = {
                token: that.token,
                code: code
            }
            that.$api.user.bindAppWX(params).then(res => {
                if (res.code == 200) {
                    that.getData()
                    that.$toast('绑定成功')
                } else {
                    that.$toast('绑定失败，请联系客服')
                }
            })
        },
        bingAPPWxData(data) {
            console.log('bingAPPWxData:',data)
            var that = this
            var params = {
                openid: data.openid,
                unionid: data.unionid,
                thumb: data.profile_image_url,
                nickname: data.name
            } 
            
            params.token = that.token
            console.log('params:',params)
            that.$api.user.bindAppWXAndroid(params).then(res => {
                if (res.code == 200) {
                    that.getData()
                    that.$toast('绑定成功')
                } else {
                    that.$toast('绑定失败，请联系客服')
                }
            })
        },
        bindH5Wx() {
            if (this.bindWX) {
                // 解绑
                var params = {
                    token: this.token
                }
                this.$api.user.unbindWX(params).then(res => {
                    if (res.code == 200) {
                        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                            var memberParams = {
                                'data': {
                                    forceLogin: 1
                                }
                            }
                            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                                
                            })
                        } else {
							this.$store.commit(LOGOUT);
                            this.$router.push("/");
                        }
                    }
                })
            } else {
                // 绑定
                window.location.href = this.getCodeUrl;
            }
            this.show = false
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
